import { render, staticRenderFns } from "./DfeSync.vue?vue&type=template&id=4ce004d9&scoped=true&"
import script from "./DfeSync.vue?vue&type=script&lang=js&"
export * from "./DfeSync.vue?vue&type=script&lang=js&"
import style0 from "./DfeSync.vue?vue&type=style&index=0&id=4ce004d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce004d9",
  null
  
)

export default component.exports